<template>
    <v-card>
        <v-flex offset-lg1>
            <span>Prev Scene Question:</span>
        </v-flex>
        <span style="margin-left:42px; color:pink;">{{ prevQuestion }}</span>
        <v-flex offset-lg1>
            <span>Condition Type</span>
        </v-flex>
        <v-flex offset-lg1>
            <span>Set Design (Time):</span>
        </v-flex>
        <span style="margin-left:42px; color:pink;">{{ setDesign }}</span>
        <v-flex offset-lg1>
            <span>Character</span>     
        </v-flex>
        <v-flex style="margin-left:42px;" v-for="(character, index) in characters" :key="index">
            <v-layout row>
                <span style="color:pink;margin-top:5px; margin-right:15px">{{ index + 1 }}. {{ character.name }}</span>                
                <v-img :src="character.assetUrl" style='border-radius:35%; max-height:30px; max-width:30px;'></v-img>
            </v-layout>            
        </v-flex>   
    </v-card>
</template>

<script>
export default {
  props: ['nodeId', 'diagramData', 'timelineContent'],
  data () {
    return {
      prevQuestion: '',
      triggers: [],
      characters: [],
      setDesign: ''
    }
  },
  components: {
  },
  mounted () {
    this.receiveTriggerTextFromChatArea()
  },
  watch: {
    nodeId () {
      let prevNodeKey = null
      let linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === this.nodeId)
      // continue to track its upper layer throngh the link, till a scene node is found
      while (typeof linkFromThisKey !== 'undefined') {
        prevNodeKey = linkFromThisKey.from
        let prevNode = this.diagramData.nodeDataArray.find(node => node.key === prevNodeKey)
        if (prevNode.category === 'Scene') {
          prevNodeKey = prevNode.key
          break
        }
        linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === prevNode.key)
      }
      if (prevNodeKey !== null) {
        let foundTriggerLine = this.triggers.find(eachLine => eachLine.nodeId === prevNodeKey)
        if (foundTriggerLine) {
          this.prevQuestion = foundTriggerLine.msg
        } else {
          this.prevQuestion = ''
        }
      }
    },
    timelineContent () {
      if (this.timelineContent !== null) {
        this.characters = this.fetchCharacters()
        this.setDesign = this.fetchSetDesign()
      }
    }
  },
  methods: {
    foundPreviousScene (key) {
      let linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === key)
        // continue to track its upper layer throngh the link, till a scene node is found
      while (typeof linkFromThisKey !== 'undefined') {
        let prevNodeKey = linkFromThisKey.from
        let prevNode = this.diagramData.nodeDataArray.find(node => node.key === prevNodeKey)
        if (prevNode.category === 'Scene') {
          return prevNode.key
        }
        linkFromThisKey = this.diagramData.linkDataArray.find(link => link.to === prevNode.key)
      }
      return -1
    },
    receiveTriggerTextFromChatArea () {
      this.$root.$on('triggerTextFromChatArea', (eachLine) => {
        this.triggers.push(eachLine)
      })
    },
    fetchCharacters () {
      if (this.timelineContent.elements) {
        let charactersElements = this.timelineContent.elements.filter(ele => ele.type === 'Character')
        return charactersElements
      }
    },
    fetchSetDesign () {
      if (this.timelineContent.elements) {
        let setDesign = this.timelineContent.elements.find(ele => ele.type === 'Prop')
        if (setDesign) {
          return setDesign.value
        } else {
          return ''
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/story-edit-view/conversation/prevCondition.vue